<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body">
  {{message}}
</div>
<div class="modal-footer">
  <button class="btn btn-sm bg-g-red" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm bg-g-lightGreen" (click)="onConfirmClick()" cdkFocusInitial>{{btnText}}</button>
</div>
